import React, { useState, useEffect } from 'react'
import './index.less'
interface TagListPropsRule {
    list: ListItemRule[]
    onChange?: (list: ListItemRule[] | ListItemRule) => void
    multi?: boolean
}
interface ListItemRule { desc: string | number, code: string | number, }
const TagList = (props: TagListPropsRule) => {
    const { list, onChange, multi = false } = props
    const [selectedList, setSelectedList] = useState<ListItemRule[]>([])
    const [selected, setSelected] = useState<ListItemRule>({ desc: '', code: '' })
    const changeSelectedMulti = (obj: ListItemRule) => {
        let index = selectedList?.findIndex(i => i.code === obj.code)
        console.log(index)
        let newSelectedList = selectedList
        if (index >= 0) {
            newSelectedList.splice(index, 1)
        } else {
            newSelectedList.push(obj)
        }
        setSelectedList(newSelectedList.concat([]))
    }
    const changeSelected = (obj: ListItemRule) => {
        if (obj.code === selected.code) {
            setSelected({ code: '', desc: '' })
        } else {
            setSelected({ ...obj })
        }
    }
    useEffect(() => {
        onChange && onChange(multi ? selectedList : selected)
    }, [selectedList, selected])
    return <div className='tag-list-container'>
        {
            list.map((item, index) => {
                return <div
                    className={`tag-item ${(selectedList.some(i => i.code === item.code) || selected.code === item.code) ? 'tag-item-active' : ''}`}
                    key={`tag-list-item-${index}-${item.code}`}
                    onClick={() => { multi ? changeSelectedMulti(item) : changeSelected(item) }}
                >
                    {item.desc}
                </div>
            })
        }
    </div>
}

export default TagList